module.exports = "https://www.niulinkcloud.cn/_next/static/media/icon2.e0b39bf18c882ca2bdc8ab147cf7b524.png";